export default __webpack_public_path__ + "img/footer-7ebbe9b6.png";